import FeaturedWork from './FeaturedWork'
import Header from './Header'
import OurService from './OurService'
import WhatMakesUsSpecial from './WhatMakesUsSpecial'

const index = () => {
    return (
        <div className="home-page ">
            <Header />
            <OurService />
            <FeaturedWork />
            <WhatMakesUsSpecial />
        </div>
    )
}

export default index
